import {
  START_REQUEST,
  STOP_REQUEST,
  FETCH_LOCATIONS_SUCCESS,
  START_TASK_VALIDATION,
  VALIDATE_TASK_SUCCESS,
} from '../actions/queriesActions';

export default (state = { categories: [], countryLocations: {}, countrySupportsZipCodes: {}, countrySubdivisionTypes: {}, taskValidationResult: {} }, action) => {
  switch (action.type) {
  case START_TASK_VALIDATION: {
    return {
      ...state,
      loading: true,
      validationRequestId: action.validationRequestId,
    };
  }
  case START_REQUEST: {
    return {
      ...state,
      loading: true,
    };
  }
  case STOP_REQUEST: {
    return {
      ...state,
      loading: false,
    };
  }
  case FETCH_LOCATIONS_SUCCESS: {
    return {
      ...state,
      countryLocations: action.countryLocations,
      countrySupportsZipCodes: action.countrySupportsZipCodes,
      countrySubdivisionTypes: action.countrySubdivisionTypes || state.countrySubdivisionTypes || {},
    };
  }
  case VALIDATE_TASK_SUCCESS: {
    return {
      ...state,
      taskValidationResult: action.taskValidationResult,
    };
  }
  default:
    return state;
  }
};
